'use strict';

const { h } = require('preact');

const DiscountBadge = ({
  option: { pricing: { formattedDiscount }, isUrgencyPricing } = {},
}) => {
  if (!formattedDiscount) {
    return null;
  }

  let discountMessageClasses = 'discount-message';
  if (isUrgencyPricing) {
    discountMessageClasses += ' urgency-pricing c-txt-err';
  } else {
    discountMessageClasses += ' c-txt-prim-dk';
  }

  return h(
    'div',
    {
      class: 'discount-message-wrapper',
    },
    h(
      'div',
      {
        class: discountMessageClasses,
      },
      formattedDiscount
    )
  );
};

module.exports = DiscountBadge;
